import { User } from '@economic/react-app';
import { AppSettingsResult } from '../../../types';

export const isESignatureTopNavbarIconHidden = (
    user: User,
    isESignatureNavbarIconHiddenLocalStorage: boolean,
    eSignatureNavbarIconVisibilitySettings: AppSettingsResult
) => {
    if (user.isAdministrator) {
        return isESignatureNavbarIconHiddenLocalStorage;
    }
    return eSignatureNavbarIconVisibilitySettings.data?.content?.isESignatureNavbarIconHidden ?? false;
};

export const getDigitalSignatureEmailValidationRegex = () => {
    return /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
};
